import axiosClient from "./AxiosClient";

class CommonApi {

    saveListOfTemplate(token, params) {
        let url = '/default/save-template?token=' + token;
        return axiosClient.post(url, params);
    }

    deleteListOfTemplate(token, name) {
        let url = '/default/delete-template';
        let params = {name, token};
        return axiosClient.get(url, {params});
    }

    getListOfTemplate(token) {
        let url = '/default/load-template';
        let params = {token};
        return axiosClient.get(url, {params});
    }

    getPaymentTerms(token) {
        let url = '/common';
        let params = {action: "payment-terms", token};
        return axiosClient.get(url, {params});
    }

    getCurrencies(token) {
        let url = '/common';
        let params = {action: "currencies",token};
        return axiosClient.get(url, {params});
    }

    getDepartments(token) {
        let url = '/common';
        let params = {action: "Departments",token};
        return axiosClient.get(url, {params});
    }

    getEmployees(token) {
        let url = '/common';
        let params = {action: "employees",token};
        return axiosClient.get(url, {params});
    }

    getUnits(token) {
        let url = '/common';
        let params = {action: "Units",token};
        return axiosClient.get(url, {params});
    }

    checkLicense(token) {
        let url = '/common/check-license';
        let params = {token};
        return axiosClient.get(url, {params});
    }

    getLayout(token) {
        let url = '/common';
        let params = {action: "layouts",token};
        return axiosClient.get(url, {params});
    }

    getInvoiceBooked(token,params) {
        let url = '/common/get-invoices-booked';
        params = {...params,token};
        return axiosClient.get(url, {params});
    }

    getInvoiceOpening(token,params) {
        let url = '/common/get-invoices-opening';
        params = {...params,token};
        return axiosClient.get(url, {params});
    }

    addCreditNote(token, bookedInvoiceNumber) {
        let url = '/common/add-credit-note?token='+token;
        return axiosClient.post(url, {bookedInvoiceNumber});
    }

    bookInvoice(token, invoiceNumber) {
        let url = '/common/book-invoice?token='+token;
        return axiosClient.post(url, {invoiceNumber});
    }
    uploadFile(token, formData) {
        let url = '/common/load-excel-file?token='+token;
        return axiosClient.post(url, formData);
    }
}

export default (new CommonApi());
